import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type ResumeType = {
  isSimulation: boolean
  isQuotation: boolean
  isProposal: boolean
}

export type DisabledStepsByResume = {
  step1: boolean
  step2: boolean
  step3: boolean
  step4: boolean
  step5: boolean
  step6: boolean
  step7: boolean
}

type Store = {
  isResumeLoading: boolean
  setIsResumeLoading: (value: boolean) => void
  isResume: boolean
  setIsResume: (value: boolean) => void
  isQuotationResume: boolean
  setQuotationResume: (value: boolean) => void
  resumeType: ResumeType
  setResumeType: (value: ResumeType) => void
  disabledStepsByResume: DisabledStepsByResume
  setDisabledStepsByResume: (value: DisabledStepsByResume) => void
}

export const useResumeStore = create<Store>()(
  devtools(
    (set, get) => ({
      isResumeLoading: true,
      setIsResumeLoading: (isResumeLoading) => set({ isResumeLoading }),
      isResume: false,
      setIsResume: (isResume) => set({ isResume }),
      isQuotationResume: false,
      setQuotationResume: (isQuotationResume) => set({ isQuotationResume }),
      resumeType: {
        isSimulation: false,
        isQuotation: false,
        isProposal: false,
      },
      setResumeType: (resumeType) => set({ resumeType }),
      disabledStepsByResume: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
        step7: false,
      },
      setDisabledStepsByResume: (disabledStepsByResume) =>
        set(() => {
          const disabledStepsByResumeState = get().disabledStepsByResume

          const mewData = {
            ...disabledStepsByResumeState,
            ...disabledStepsByResume,
          }

          return { disabledStepsByResume: mewData }
        }),
    }),
    { name: 'ResumeStore' },
  ),
)
